import { useEffect, useState } from 'react';
import StudyFieldsService from 'services/StudyFieldsService';

export default function useStudyFields() {
  const [studyFields, setStudyFields] = useState([]);

  useEffect(() => {
    const fetchAllStudyFields = async () => {
      try {
        const response = await StudyFieldsService.fetchAll();

        setStudyFields(response.data);
      } catch (error) {
        console.log(error.response.data.message);
      }
    };

    fetchAllStudyFields();
  }, []);

  return studyFields;
}
